// Merge widget params with page params (like bookings-calendar-widget pattern)
import widgetStylesParams, {
  customCssVars as widgetCustomCssVars,
} from '../WixServices/stylesParams';
import pageStylesParams from './pageStylesParams';

// Merge the params objects (spread the created params, not the definitions)
export default {
  ...widgetStylesParams,
  ...pageStylesParams,
};

// Re-export widget's customCssVars
export const customCssVars = widgetCustomCssVars;
